import { Button, Card, CardContent, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { fget } from "../../../API/callsAPI";
import StorageOverview from "../../Updates/Widgets/UpdatesPageTodoWidgets/TodoWidgetsComponents/StorageOverview";
import projectDetailsSettingsStyles from "./ProjectDetailsSettings.style";
import { PencilLine } from "phosphor-react";
import commonStyles from "../../../Utils/commonStyles";

const ProjectDetailsSettingsOverview = ({ projectId }) => {
  const classes = projectDetailsSettingsStyles();
  const commonClasses = commonStyles();
  const [projectDetails, setProjectDetails] = useState({});
  const getProjectDetails = async () => {
    try {
      const res = await fget({
        url: `project/${projectId}/`,
      });
      setProjectDetails(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (projectId) {
      getProjectDetails();
    }
  }, [projectId]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid
          xs={12}
          md={8}
          style={{
            padding: "0px 10px 0px 0px",
          }}
        >
          <div
            className={commonClasses.flexBetween}
            style={{
              paddingLeft: "20px",
            }}
          >
            <h2>Project Details</h2>
            <Button startIcon={<PencilLine />}>Edit Project</Button>
          </div>
          <div className={classes.root}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <div
                  style={{
                    display: "flex",
                    // alignItems:"center",
                    gap: "10px",
                  }}
                >
                  <div className={classes.imageContentDiv}>
                    <img
                      className={classes.projectThumbnail}
                      src={projectDetails.thumbnail}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <div className={commonClasses.flexAndGap8Px}>
                      <div>
                        <span className={classes.inputLabel}>Project Name</span>
                        <div className={classes.cardContentDiv3}>
                          <TextField
                            type="text"
                            InputProps={{
                              disableUnderline: true,
                              style: {
                                fontFamily: "Poppins",
                              },
                            }}
                            className={classes.cardContentInput1}
                            placeholder="Enter project name"
                            name="projectName"
                            value={projectDetails.name}
                          />
                        </div>
                      </div>
                      <div>
                        <span className={classes.inputLabel}>Abbreviation</span>
                        <div className={classes.cardContentDiv3}>
                          <TextField
                            type="text"
                            InputProps={{
                              disableUnderline: true,
                              style: {
                                fontFamily: "Poppins",
                              },
                            }}
                            className={classes.cardContentInput1}
                            placeholder="Enter project abbreviation"
                            name="abbreviation"
                            value={projectDetails.abbreviation}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={classes.cardContentDiv4}>
                      <span className={classes.inputLabel}>Description</span>
                      {/* <Asterisk size={12} color="#FF0000" weight="fill" /> */}
                      <div>
                        <TextField
                          type="text"
                          id="desc"
                          placeholder="Enter a project description"
                          className={classes.cardContentInput1}
                          style={{ height: "70px", overflow: "auto" }}
                          InputProps={{
                            disableUnderline: true,
                            style: {
                              fontFamily: "Poppins",
                            },
                          }}
                          name="description"
                          value={projectDetails.description}
                          multiline
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </Grid>
        <Grid xs={12} md={4} style={{ marginTop: "10px" }}>
          <StorageOverview />
        </Grid>
      </Grid>
    </div>
  );
};

export default ProjectDetailsSettingsOverview;
